// Firebase
import firebase from 'firebase/app'
import { $firebaseConfig } from '@themeConfig'

// Initialize Firebase
firebase.initializeApp($firebaseConfig)
